module.exports = __webpack_public_path__ + "assets/bgcode.ecae5c82.svg";